import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ConversationModuleState } from 'src/core/states/conversation/conversation-module.state';
import { Observable } from 'rxjs';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { Select, Store } from '@ngxs/store';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { map } from 'rxjs/operators';
import { ConversationCallListViewOption } from 'src/core/models/generic-lookup-type/conversation/conversation-call-list-view-option.glt';
import { ConversationService } from 'src/core/services/conversation/conversation.service';
import { CompactPlayerComponent } from 'src/ca-shared/player/compact-player/compact-player.component';

@Component({
    selector: 'ca-conversation-call-list',
    templateUrl: './call-list.component.html',
    styleUrls: ['./call-list.component.scss'],
    standalone: false
})
export class CallListComponent implements OnInit {
  @Select(ConversationModuleState.getActiveList)
  activeList$: Observable<number>;

  @Select(ConversationModuleState.getActiveView)
  activeView$: Observable<number>;

  viewOptions$: Observable<GenericLookupDto[]>;
  viewOptions: GenericLookupDto[] = [];

  @Input()
  compactPlayer: CompactPlayerComponent;

  @Output()
  conversationIdChange: EventEmitter<{
    id: number;
  }> = new EventEmitter();

  @Output()
  dataLoaded = new EventEmitter();

  standardListVisible = true;

  constructor(private store: Store, private conversationService: ConversationService) {
    this.viewOptions$ = this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(ConversationCallListViewOption)));

    this.viewOptions$.subscribe(genericLookups => {
      this.viewOptions = genericLookups;
    });

    this.activeView$.subscribe(activeView => {
      this.standardListVisible = activeView === ConversationCallListViewOption.standard;
    });
  }

  ngOnInit() {}

  onConversationIdChanged(conversationId) {
    this.conversationIdChange.emit(conversationId);
  }

  onDataLoaded() {
    this.dataLoaded.emit();
  }
}
